module.exports = __webpack_public_path__ + "static/media/girl3.91a92ae4.jpg";